import { gql } from '@apollo/client'

const UPSERT_NONPROFIT_ORG_SETTINGS = gql`
  mutation upsertNonprofitOrgSettings(
    $nonprofitOrgId: Int!
    $orgSettings: OrgSettingsInput!
    $nonprofitOrgRelations: NonprofitOrgRelationsInput
    $orgFinancialSettings: OrgFinancialSettingsInput
  ) {
    upsertNonprofitOrgSettings(
      nonprofitOrgId: $nonprofitOrgId
      orgSettings: $orgSettings
      nonprofitOrgRelations: $nonprofitOrgRelations
      orgFinancialSettings: $orgFinancialSettings
    ) {
      id
      name
    }
  }
`

export default UPSERT_NONPROFIT_ORG_SETTINGS
